import { useEffect } from 'react';
import { webLogger } from '@/common/log';
import yoda from '@kibt/bridge';
import { versionCompare } from '@kibt/web-utils/version';
import { isAndroid, appVersion } from './device-info';
import { radar } from '@/common/log';
import { isIOS } from '@kibt/krn-utils';
import { useQuery } from '@/hooks/useQuery';
import { useExtParamsObject } from '@/page/detail/views/content/utils';

export function useCheckMediaId() {
    const extParamsObj = useExtParamsObject();
    const { cT, cId } = extParamsObj;
    useEffect(() => {
        try {
            // console.log(extParamsObj, 'extParamsObj');
            // 短视频特定场景下mediaId合法性监控
            if (+cT === 1 && cId?.toString()?.length !== 15) {
                radar.event({
                    name: 'CUSTOM_COFIRM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_COFIRM_MEDIA_ID_ERROR',
                    params: {
                        extParamsObj,
                    },
                });
            }
            // 直播间特定场景下mediaId合法性监控
            if ([0, '0'].includes(cT) && cId?.toString()?.length !== 9) {
                radar.event({
                    name: 'CUSTOM_COFIRM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_COFIRM_MEDIA_ID_ERROR',
                    params: {
                        extParamsObj,
                    },
                });
            }
            // 店铺页(达人店铺页)搜索特定场景下mediaId合法性监控
            if ([4, 10].includes(+cT) && !(cId?.toString()?.length <= 7 && cId?.toString()?.length >= 5)) {
                radar.event({
                    name: 'CUSTOM_COFIRM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_COFIRM_MEDIA_ID_ERROR',
                    params: {
                        extParamsObj,
                    },
                });
            }
            // 商城搜索特定场景下mediaId合法性监控
            if (+cT === 29 && [0, 1, 2].includes(+cId)) {
                radar.event({
                    name: 'CUSTOM_COFIRM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_COFIRM_MEDIA_ID_ERROR',
                    params: {
                        extParamsObj,
                    },
                });
            }
        } catch (error) {
            radar.event({
                name: 'CUSTOM_COFIRM_MEDIA_ID_SEND_FAIL',
                eventType: 'CUSTOM_COFIRM_MEDIA_ID_SEND_FAIL',
                params: {
                    extParamsObj,
                },
            });
        }
    }, []);
}

export function useCheckMediaSource(radarEventName: string) {
    const extParams = useQuery('extParams') as string;
    useEffect(() => {
        try {
            const media_source = JSON.parse(extParams)?.cT;
            radar.event({ name: radarEventName, params: { media_source, extParams } });
        } catch (e) {
            radar.event({ name: radarEventName, params: { media_source: '', extParams } });
        }
    }, []);
}
const bindTypeMap = {
    pv(value) {
        webLogger.sendLog(value);
    },
    show(value) {
        webLogger.sendLog(value);
    },
    click(el, value) {
        // el.onclick = function () {
        //     clickLog(el, value);
        // };
    },
};
export const useLogAttribute = (logConfig: any) => {
    useEffect(() => {
        if (logConfig && logConfig.type !== 'custom' && bindTypeMap[logConfig.type]) {
            const type = logConfig.type;
            setTimeout(() => {
                bindTypeMap[type](logConfig);
            }, 50);
        }
    }, []);
    return null;
};

let forbidWebDrag;

/**
 * 安卓 版本大于 9.0.20 时候 才调用这个桥 ios不需要
 */
export function onForbidWebDrag(forbid: boolean) {
    // 如果设置过桥了，不要连续无休止调用
    if (forbidWebDrag === forbid) {
        return;
    } else {
        // 没有调用过记录调用
        forbidWebDrag = forbid;
    }
    // |-1 |version1<version2|
    // |1  |version1>version2|
    // 只有版本大于 9.0.20 时候 才调用这个桥
    console.log('调用forbidWebDrag', forbid);
    if (isAndroid && versionCompare(appVersion, '9.0.20') === 1) {
        try {
            (yoda.component as any).forbidWebDrag({ isForbid: forbid });
        } catch (error) {
            console.log('调用forbidWebDrag 失败');
        }
    }
    // IOS 版本大于 9.9.40 时候 才调用这个桥
    if (isIOS && versionCompare(appVersion, '9.9.40') > -1) {
        ((yoda as any).kwaiInvoke ?? yoda.invoke)?.('component.forbidWebDrag', { isForbid: forbid }).catch(err => {
            console.log('调用 component.forbidWebDrag 失败');
        });
    }
}
